import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  data: {
    content: [],
    links: [],
    page: {},
  },
  apiError: null,
  isFetching: false,
};

const fetchCategoriesStatsRequest = state => ({
  ...state,
  isFetching: true,
  apiError: null,
});

const fetchCategoriesStatsSuccess = (state, { data }) => ({
  ...state,
  data,
  isFetching: false,
  apiError: null,
});

const fetchCategoriesStatsFailure = (state, { error }) => ({
  ...state,
  isFetching: false,
  apiError: error,
});

export default createReducer(initialState, {
  [types.FETCH_CATEGORIES_STATS_DISTRIBUTION_REQUEST]: fetchCategoriesStatsRequest,
  [types.FETCH_CATEGORIES_STATS_DISTRIBUTION_SUCCESS]: fetchCategoriesStatsSuccess,
  [types.FETCH_CATEGORIES_STATS_DISTRIBUTION_FAILURE]: fetchCategoriesStatsFailure,
});
